
/**
 * 默认面包屑路径
 */
export const getDefaultBreadcrumbItems = (serviceName?: string) => [
  { title: '首页' },
  { title: '社會工作局' },
  { title: '申請成為寄養父母' },
];

export enum securityLevel {
  SATISFACTORY = 1,
  HIGH = 2,
  VERY_HIGH = 3,
}

export enum StepType {
  //note = 'note',
  form = 'form',
  dataCheck = 'dataCheck',
  faceRecognition = '4',
}

export interface StepInfo {
  stepName: string;
  stepType: StepType;
}

export const stepInfo: StepInfo[] = [
  /* {
    stepName: '申請須知',
    stepType: StepType.note,
  }, */
  {
    stepName: '填寫資料',
    stepType: StepType.form,
  },
  {
    stepName: '資料確認',
    stepType: StepType.dataCheck,
  },
  {
    stepType: StepType.faceRecognition,
    stepName: '身份識別',
  },
];
